import React, { Component, useContext } from 'react';
import { MyContext, MyGlobal, MyHeading, MyAlert } from '../components/GlobalContext';
import LinkButton from '../components/LinkButton';
import * as $ from 'jquery';
import * as MySound from '../components/MySound';


export class ToteMoveQC extends Component {
    static displayName = ToteMoveQC.name;
    constructor(props) {
        super(props);
        this.state = {
            data: [],
            tote: props?.location?.state?.tote,
            hdrID: "",
            productCode: "",
            barcode: "",
            qty: 0,
            lineID: "",
            alertMessage:"",
        };
        this.history = props.history;
    }

    componentDidMount() {
        this.txtQty.focus();
        this.populateData();
    }

    goto(page) {
        this.history.push(page);
    }
    rowClicked(e, row, value) {

    }

    renderTable(data) {
        return (
            <table className='table table-striped' aria-labelledby="tabelLabel">
                <thead>
                    <tr>
                        <th>SKU</th>
                        <th>QTY</th>
                        <th>Barcode</th>
                    </tr>
                </thead>
                <tbody>
                    {data.map(row =>
                        <tr key={row.ReceiptHdrId}
                            onClick={(e, key) => {
                                $(e.currentTarget).closest("table").find("tr").removeClass("selected");
                                $(e.currentTarget).addClass("selected");
                                this.setState({ hdrID: row.ReceiptHdrId, barcode: row.Barcode, productCode: row.ProductCode, lineID: row.ID });
                                this.txtQty.select();
                                this.txtQty.focus();
                            }}>
                            <td>{row.ProductCode}</td>
                            <td>{row.RecievedQty}</td>
                            <td>{row.Barcode}</td>
                        </tr>
                    )}
                </tbody>
            </table>
        );
    }

    render() {
        let contents = this.state.loading
            ? <p><em>Loading...</em></p>
            : this.renderTable(this.state.data);

        let alertMessage = this.state.alertMessage;
        alertMessage = alertMessage != "" ? <MyAlert variant="danger">{alertMessage}</MyAlert> : "";
        return (
            <div>
                {alertMessage}
                <MyHeading>Select Product to Confirm QTY</MyHeading>
                <div className="tableHolder hm-50vh mb-3">
                    {contents}
                </div>
                <div className="form-group">
                    <label htmlFor="txtProduct">Product</label>
                    <input
                        type="text"
                        readOnly
                        className="form-control"
                        name="txtProduct"
                        value={this.state.productCode}
                        onChange={(e) => {
                            this.setState({ productCode: e.target.value });
                        }}
                    />
                </div>
                <div className="form-group">
                    <label htmlFor="txtBarcode">Barcode</label>
                    <input
                        type="text"
                        readOnly
                        className="form-control"
                        name="txtBarcode"
                        value={this.state.barcode}
                        onChange={(e) => {
                            this.setState({ barcode: e.target.value });
                        }}
                    />
                </div>
                <div className="form-group">
                    <label htmlFor="txtQty">Quantity</label>
                    <input
                        type="number"
                        className="form-control"
                        value={this.state.qty}
                        onChange={(e) => {
                            this.setState({ qty: e.target.value });
                        }}
                        name="txtQty"
                        id="txtQty"
                        autoFocus
                        ref={(input) => { this.txtQty = input; }}
                    />
                </div>
                <div className="container">
                    <div className="row form-group">
                        <button className="btn btn-success col-12 mb-2" onClick={() => { this.sendData(); }}>Confirm Quantity</button>
                       
                    </div>
                </div>
            </div>
        );
    }

    async sendData() {
        //   const token = await authService.getAccessToken();
        let qty = this.state.qty;
        let userID = MyGlobal.user;
        let lineID = this.state.lineID;
        let hdrID = this.state.hdrID.trim();
        let productCode = this.state.productCode.trim();
        let url = `api/Tote/SetMoveProductApprovedByTote?hdrID=${hdrID}&lineID=${lineID}&productCode=${productCode}&qty=${qty}&userID=${userID}`;
        if (qty <= 0 || lineID == "") {
            this.setState({ alertMessage: MyGlobal.strings.invalidQty });
            return
        }
        const response = await fetch(url, {
            //      headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        });
        const data = await response.json();
        MySound.play(MySound.Sound.next);
        var updatedData =  await this.populateData();
        if (updatedData && updatedData <= 0) {
            this.goto('ToteApproval');
        }
    }

    async populateData() {
        //   const token = await authService.getAccessToken();
        let url = `api/Tote/GetMoveToteDetails?tote=${this.state.tote.trim()}`;
        const response = await fetch(url, {
            //      headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        });
        const data = await response.json();
        this.setState({
            data: data,
            loading: false,
            hdrID: "",
            productCode: "",
            barcode: "",
            qty: 0,
            lineID: "",
            alertMessage: "",
        });
        return data;
    }
}
